export default "__VITE_ASSET__BvyDv_Nx__"